// CUSTOM JS TO APPLY ONLY TO INDEX PAGE
$(function(){
    // MODAAL & ANIMATION
    var $fixedbackground = $(".fixed-background");
    var $indexVideo = $('.index-video');
    var $scrollBar = $(".scrollbar");
    var $scrollText = $(".scrollbar-text");
    var $pagetopBar = $(".pagetopbar");
    var $pagetopText = $(".pagetopbar-text");

    function afterVideo(){
        // ロゴFadein
        setTimeout(function() {
            $(".slider-logo").fadeIn(4000);
        }, 3000);
        // ヘッダーFadein
        setTimeout(function() {
            $(".index-header .original-header").animate({opacity: 1}, 2000);
            addAnimation();
        }, 1000);
        setTimeout(function() {
            $(".index-header .header-background").animate({opacity: 1}, 4000);
            $('.slick-wrap').slick('slickPlay');
        }, 2000);
        setTimeout(function() {
            $scrollBar.css('opacity', 1).css('transform', 'translate(0, 0)');
            $scrollText.css('opacity', 1).css('transform', 'translate(0, 0) rotate(90deg)');
        }, 4000);
    }

    function addAnimation(){
        var windowWidth = $(window).width();
        if(windowWidth >= 1920){
            $fixedbackground.addClass("animation-lg5");
        }else if(windowWidth < 1920 && windowWidth >= 1536){
            $fixedbackground.addClass("animation-lg4");
        }else if(windowWidth < 1536 && windowWidth >= 1440){
            $fixedbackground.addClass("animation-lg3");
        }else if(windowWidth < 1440 && windowWidth >= 1366){
            $fixedbackground.addClass("animation-lg2");
        }else if(windowWidth < 1366 && windowWidth >= 1280){
            $fixedbackground.addClass("animation-lg1");
        }else if(windowWidth < 1280 && windowWidth >= 768){
            $fixedbackground.addClass("animation-md");
        }else if(windowWidth < 767){
            $fixedbackground.addClass("animation-sm");
        }
    }

    // ビデオモーダル
    var dataVisited = sessionStorage.getItem('userOkiVisit');
    if(dataVisited == "visited"){
        afterVideo();
    }else{
        $indexVideo.modaal({
            // start_open: true,
            fullscreen: true,
            custom_class: "movie-modaal"
        });
        afterVideo();
        $(".movie-modaal-skip").click(function(){
            $indexVideo.modaal('close');
            afterVideo();
        });
        $(".movie-modaal video").on("ended", function(){
            $indexVideo.modaal('close');
            afterVideo();
        });
    }

    // 何回目かのセッションを記録
    //データを保存
    sessionStorage.setItem('userOkiVisit', 'visited');
    //データを取得
    var dataVisited = sessionStorage.getItem('userOkiVisit');

    // スライダー
    $(".slick-wrap").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        fade: true,
        dots: true,
        dotsClass: 'slide-dot-wrap',
        easing: "ease",
        speed: 2000
    });
    $('.slick-wrap').slick('slickPause');
    $(".gallery-slick").slick({
        slidesToShow: 3.5,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        responsive: [{
            breakpoint: 600,
            settings: {
              slidesToShow: 1.5
            }
      
        }]
    });

    // スクロール量に応じた処理
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();
    var $scrollWrapper = $(".scroll-element");
    var $aboutWrapper = $(".fadein-content");
    var $slickDots = $(".slide-dot-wrap");
    // var $collectionWrapper = $(".index-collections");
    var collectionWrapper = $(".index-slick-wrapper").offset().top + $(".index-slick-wrapper").outerHeight(true);
    if(windowWidth < 600){
        if(collectionWrapper < 10){
            var collectionWrapper = 1800;
        }
    }
    var indexCollectionPosition = collectionWrapper - windowHeight -200;
    $(window).scroll(function() {
        // ページのスクロール量を取得
        var scroll = $(this).scrollTop();
        if(scroll > 400 && scroll < indexCollectionPosition){
            $scrollWrapper.addClass("blur");
            $aboutWrapper.fadeIn();
        }else{
            $scrollWrapper.removeClass("blur");
            $aboutWrapper.fadeOut();
        }
        // slickdot Fadeout
        if (scroll >= 1) {
            $slickDots.hide();
        }else{
            $slickDots.show();
        }
        // スクロールバー Fadeout
        if (scroll >= 5) {
            $scrollBar.removeAttr("style");
            $scrollText.removeAttr("style");
        } else {
            $scrollBar.css('opacity', 1).css('transform', 'translate(0, 0)');
            $scrollText.css('opacity', 1).css('transform', 'translate(0, 0) rotate(90deg)');
        }
        // スクロールバー Fadeout
        if (scroll <= 1000) {
            $pagetopBar.removeAttr("style");
            $pagetopText.removeAttr("style");
        } else {
            $pagetopBar.css('opacity', 1);
            $pagetopText.css('opacity', 1);
        }

    });

    // Smoothscroll
    $('a.scroll-bar-jquery').click(function(){
        var speed = 800;
        var position = windowHeight;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
    $('a.pagetop-bar-jquery').click(function(){
        var speed = 800;
        $("html, body").animate({scrollTop:0}, speed, "swing");
        return false;
    });
});